import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from 'react';

export interface RowActionsMenuProps {
  onAction: (action: string) => void;
  serviceId: number;
}

const MENU_ITEMS = [
  { key: 'assign_tech', label: 'Assign Tech' },
  { key: 'schedule', label: 'Schedule' },
  { key: 'add_note', label: 'Add Note' },
  { key: 'update_status', label: 'Update Status' },
] as const;

export const RowActionsMenu: React.FC<RowActionsMenuProps> = ({
  onAction,
  serviceId,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action: string) => {
    handleClose();
    onAction(action);
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        aria-label={`Actions for service ${serviceId}`}
        sx={{ color: 'v4.accent' }}
      >
        <MoreVertIcon sx={{ fontSize: 18 }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        slotProps={{
          paper: {
            sx: {
              boxShadow: '0 4px 12px rgba(0,0,0,.1)',
              borderRadius: 1.5,
              minWidth: 160,
            },
          },
        }}
      >
        {MENU_ITEMS.map((item) => (
          <MenuItem
            key={item.key}
            onClick={() => handleAction(item.key)}
            sx={{ fontSize: '13px', py: 0.75 }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
